"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.icons = exports["default"] = exports.IconList = exports.Icon = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("../style/fonts.css");
var _excluded = ["type"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
//TODO improve the icons
//remove some of the bad ones and add any that may be useful

var icons = exports.icons = {
  Design: "c2o-elements-icon-design",
  Embroidery: "c2o-elements-icon-embroidery",
  Garments: "c2o-elements-icon-garments",
  NameNumber: "c2o-elements-icon-nameNumber",
  Print: "c2o-elements-icon-print",
  Redraw: "c2o-elements-icon-redraw",
  Text: "c2o-elements-icon-text",
  TShirt: "c2o-elements-icon-t-shirt",
  ChevronDown: "c2o-elements-icon-chevron-down",
  ChevronLeft: "c2o-elements-icon-chevron-left",
  ChevronRight: "c2o-elements-icon-chevron-right",
  ChevronUp: "c2o-elements-icon-chevron-up",
  Arrows: "c2o-elements-icon-arrows",
  Bars: "c2o-elements-icon-bars",
  CheckCircle: "c2o-elements-icon-check-circle",
  FileCheck: "c2o-elements-icon-file-check",
  Check: "c2o-elements-icon-check",
  Clone: "c2o-elements-icon-clone",
  Cog: "c2o-elements-icon-cog",
  Expand: "c2o-elements-icon-expand-arrows",
  Eye: "c2o-elements-icon-eye",
  Image: "c2o-elements-icon-image",
  Images: "c2o-elements-icon-images",
  Download: "c2o-elements-icon-download",
  Upload: "c2o-elements-icon-upload",
  InfoCircle: "c2o-elements-icon-info-circle",
  ArrowLeft: "c2o-elements-icon-long-arrow-left",
  Pointer: "c2o-elements-icon-map-marker-alt",
  ObjectGroup: "c2o-elements-icon-object-group",
  Pencil: "c2o-elements-icon-pencil",
  Phone: "c2o-elements-icon-phone",
  PlusSquare: "c2o-elements-icon-plus-square",
  Extras: "c2o-elements-icon-puzzle-piece",
  Redo: "c2o-elements-icon-redo",
  Bag: "c2o-elements-icon-shopping-bag",
  TimesCircle: "c2o-elements-icon-times-circle",
  Close: "c2o-elements-icon-times",
  Bin: "c2o-elements-icon-trash",
  Undo: "c2o-elements-icon-undo",
  Exclamation: "c2o-elements-icon-exclamation-triangle",
  Search: "c2o-elements-icon-search",
  Rotate: "c2o-elements-icon-rotate",
  Vector: "c2o-elements-icon-vector",
  DPI300: "c2o-elements-icon-dpi300",
  RotateTShirt: "c2o-elements-icon-rotate-t-shirt"
};
var Icon = exports.Icon = function Icon(props) {
  var type = props.type,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement("em", _extends({}, otherProps, {
    className: icons[type]
  }));
};
var IconList = exports.IconList = function IconList() {
  return Object.keys(icons).map(function (key) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: key,
      title: key,
      className: "icon"
    }, /*#__PURE__*/_react["default"].createElement(Icon, {
      type: key
    }));
  });
};
Icon.propTypes = {
  type: _propTypes["default"].oneOf(Object.keys(icons))
};
var _default = exports["default"] = Icon;